<div [formGroup]="templateForm">
    <p-toast></p-toast>
    <div>
        Name
        <input pInputText formControlName="name">
        Language: <p-dropdown placeholder="select language" [options]="languages" formControlName="language"
            optionLabel="name"></p-dropdown>
    </div>
    <div>
        Subject:
    </div>
    <div>
        <input pInputText formControlName="subject" class="subject-input">
    </div>
    <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
    <p-button label="Submit" (onClick)="sendTemplate()" [disabled]="processing"></p-button>
</div>